export const RESET_POST_TYPE_FILTER = 'RESET_POST_TYPE_FILTER';
export const resetPostTypeFilter = () => ({ type: RESET_POST_TYPE_FILTER });

export const RESET_CATEGORY_FILTER = 'RESET_CATEGORY_FILTER';
export const resetCategoryFilter = () => ({ type: RESET_CATEGORY_FILTER });
